<div class="privacy-container">
  <div class="privacy-content">
    <!-- Logo Section -->
    <div class="logo-section">
      <img src="assets/logo-transparent.svg" alt="Hebern Logo" class="logo" />
    </div>

    <!-- Header -->
    <div class="privacy-message">
      <h1 class="privacy-title">Privacy Policy</h1>
      <p class="privacy-subtitle">Last updated: {{ lastUpdated }}</p>
    </div>

    <!-- Content Card -->
    <div class="privacy-card">
      <div class="card-content">
        <p>
          At Hebern, one of our top priorities is the
          privacy of our visitors and clients. This Privacy Policy document
          contains types of information that is collected and recorded by Hebern
          and how we use it.
        </p>
        <p>
          If you have additional questions or require more information about our
          Privacy Policy, do not hesitate to contact us through email at
          <a href="mailto:support@hebern.com">support&#64;hebern.com</a>.
        </p>
        <p>
          This privacy policy applies only to our online activities and is valid
          for visitors to our website with regards to the information that they
          shared and/or collect in Hebern. This policy is not applicable to any
          information collected offline or via channels other than this website.
        </p>

        <h2>Consent</h2>
        <p>
          By using our website, you hereby consent to our Privacy Policy and agree
          to its terms.
        </p>

        <h2>Information We Collect</h2>
        <p>
          The personal information that you are asked to provide, and the reasons
          why you are asked to provide it, will be made clear to you at the point
          we ask you to provide your personal information.
        </p>
        <p>
          If you contact us directly, we may receive additional information about
          you such as your name, email address, the contents of the
          message and/or attachments you may send us, and any other information
          you may choose to provide.
        </p>
        <p>
          When you register for an Account, we may ask for your contact
          information, including items such as name, company name, address, email
          address, and telephone number.
        </p>

        <h2>How We Use Your Information</h2>
        <p>We use the information we collect in various ways, including to:</p>
        <ul class="privacy-list">
          <li>Improve, personalize, and expand our website</li>
          <li>Understand how you use our products</li>
          <li>Develop new products, services, features, and functionality</li>
          <li>Send you vital information</li>
          <li>Find and prevent fraud</li>
          <li>Aggregate and anonymize data for our shareholders and investors</li>
        </ul>

        <h2>How We Don't Use Your Information</h2>
        <p>We do not user your information for any other purpose than the ones stated in this privacy policy. 
          We do not sell your information to third parties. We will not send you spam emails. We will not reveal
          identifiable information to investors or shareholders.</p>

        <h2>Log Files</h2>
        <p>
          Hebern follows a standard procedure of using log files. These files log
          visitors when they visit websites and use our products. The information collected by log
          files may include internet protocol (IP) addresses, browser type, Internet
          Service Provider (ISP), date and time stamp, referring/exit pages, and
          the number of clicks. This information is used to
          analyze trends, administer our products, track users' movement on
          our products, and gather demographic information.
        </p>

        <h2>Cookies and Web Beacons</h2>
        <p>
          Hebern uses 'cookies' on our website. These cookies are used to
          store information including visitors' preferences, and the pages on the
          website that the visitor accessed or visited. The information is used to
          optimize the users' experience by customizing our web page content based
          on visitors' browser type and/or other information.
        </p>

        <h2>CCPA Privacy Policy (Do Not Sell My Personal Information)</h2>
        <p>
          Under the CCPA, among other rights, California consumers have the right
          to:
        </p>
        <ul class="privacy-list">
          <li>
            Request that a business that collects a consumer's personal data
            disclose the categories and specific pieces of personal data that a
            business has collected about consumers.
          </li>
          <li>
            Request that a business delete any personal data about the consumer
            that a business has collected.
          </li>
          <li>
            Request that a business that sells a consumer's personal data, not
            sell the consumer's personal data.
          </li>
        </ul>
        <p>
          If you make a request, we have one month to respond to you. If you would
          like to exercise any of these rights, please contact us.
        </p>

        <h2>GDPR Privacy Policy (Data Protection Rights)</h2>
        <p>
          We would like to make sure you are fully aware of all of your data
          protection rights. Every user is entitled to the following:
        </p>
        <ul class="privacy-list">
          <li>
            The right to access – You have the right to request copies of your
            personal data. We may charge you a small fee for this service.
          </li>
          <li>
            The right to rectification – You have the right to request that we
            correct any information you believe is inaccurate. You also have the
            right to request that we complete the information you believe is
            incomplete.
          </li>
          <li>
            The right to erasure – You have the right to request that we erase your
            personal data, under certain conditions.
          </li>
          <li>
            The right to restrict processing – You have the right to request that
            we restrict the processing of your personal data, under certain
            conditions.
          </li>
          <li>
            The right to object to processing – You have the right to object to our
            processing of your personal data, under certain conditions.
          </li>
          <li>
            The right to data portability – You have the right to request that we
            transfer the data that we have collected to another organization, or
            directly to you, under certain conditions.
          </li>
        </ul>
        <p>
          If you make a request, we have one month to respond to you. If you would
          like to exercise any of these rights, please contact us.
        </p>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="contact-section">
      <h3>Contact Us</h3>
      <p>If you have questions about this Privacy Policy, please reach out.</p>
      <p class="email-link">
        <a href="mailto:support@hebern.com">support&#64;hebern.com</a>
      </p>
    </div>
  </div>
</div>
